export default __webpack_public_path__ + "static/media/5.2Vid.45944f71.mp4";